"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var ButtonLink_1 = require("components/Buttons/ButtonLink");
var ButtonPrim_1 = require("components/Buttons/ButtonPrim");
var ButtonsHolder_1 = __importDefault(require("components/Inputs/Buttons/ButtonsHolder"));
var hooks_1 = require("utils/hooks");
var ConfirmMessageDetails_1 = __importDefault(require("./ConfirmMessageDetails"));
var mappers_1 = require("./mappers");
var OptimiseFeedback_1 = __importDefault(require("./OptimiseFeedback"));
var RecommendationContext_1 = require("./RecommendationContext");
var OptimiseButtons = function (_a) {
    var _b, _c, _d;
    var recommendation = _a.recommendation, _e = _a.activateText, activateText = _e === void 0 ? 'Activate' : _e, _f = _a.deferText, deferText = _f === void 0 ? 'I’ll do it later' : _f, _g = _a.irrelevantText, irrelevantText = _g === void 0 ? 'Not relevant' : _g, children = _a.children;
    var _h = __read((0, hooks_1.useRecommendationSubmitter)(recommendation), 2), updateRecommendation = _h[0], isSending = _h[1];
    var markUsed = function () { return updateRecommendation({ status: interfaces_1.RECOMMENDATIONS_STATUS.USED }, 'originalDataOnUse'); };
    var markIrrelevant = function () { return (updateRecommendation({ status: interfaces_1.RECOMMENDATIONS_STATUS.REJECTED }, 'originalDataOnReject')); };
    var deferIt = function () { return updateRecommendation({ status: interfaces_1.RECOMMENDATIONS_STATUS.DEFERRED }, 'originalDataOnDefer'); };
    var undo = function () { return updateRecommendation({ status: null }); };
    var actioned = recommendation.status;
    var isUsed = recommendation.status === interfaces_1.RECOMMENDATIONS_STATUS.USED;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "mt-5 pt-6 pb-3 top-border pl-3" }, { children: [(!actioned || isUsed) && ((0, jsx_runtime_1.jsx)(ConfirmMessageDetails_1.default, { heading: (_b = mappers_1.CONFIRM_MESSAGE_HEADING[recommendation.type]) === null || _b === void 0 ? void 0 : _b[isUsed ? 'used' : 'unused'], details: (_d = (_c = mappers_1.CONFIRM_MESSAGE_DETAILS[recommendation.type]) === null || _c === void 0 ? void 0 : _c[isUsed ? 'used' : 'unused']) === null || _d === void 0 ? void 0 : _d.call(_c, recommendation) })), isUsed && children, (0, jsx_runtime_1.jsx)(ButtonsHolder_1.default, __assign({ className: "hover-show" }, { children: recommendation.status
                    ? (0, jsx_runtime_1.jsx)(ButtonLink_1.ButtonLinkPink, __assign({ className: "px-0 mr-0", onClick: undo, isSending: isSending }, { children: "Undo" }))
                    : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ButtonPrim_1.ButtonPinkLg, __assign({ onClick: markUsed, isSending: isSending, disabled: actioned }, { children: activateText })), (0, jsx_runtime_1.jsx)(ButtonLink_1.ButtonLinkPink, __assign({ onClick: deferIt, isSending: isSending, disabled: actioned, noMargin: true }, { children: deferText })), (0, jsx_runtime_1.jsx)(ButtonLink_1.ButtonLinkPink, __assign({ onClick: markIrrelevant, isSending: isSending, disabled: actioned, noMargin: true }, { children: irrelevantText }))] })) })), actioned && !isUsed && (0, jsx_runtime_1.jsx)(OptimiseFeedback_1.default, {})] })));
};
exports.default = (0, RecommendationContext_1.RecommendationHoC)(OptimiseButtons);
